import { Injectable, signal } from '@angular/core';

export interface ToastInfo {
  body: string;
  html?: boolean;
  className: string;
  delay?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toasts = signal<ToastInfo[]>([]);
  readonly toasts = this._toasts.asReadonly();

  notifySuccess(message: string, options?: { header?: string; delay?: number; html?: boolean }) {
    this.show({ body: message, delay: options?.delay ?? 3000, html: options?.html, className: 'bg-success text-white' });
  }

  notifyError(message: string, options?: { header?: string; delay?: number }) {
    this.show({ body: message, delay: options?.delay ?? 8000, className: 'bg-danger text-white' });
  }

  show(toast: ToastInfo) {
    this._toasts.update(list => [...list, toast]);
  }

  remove(toast: ToastInfo) {
    this._toasts.update(list => list.filter(t => t !== toast));
  }
}
